import React from 'react';

export default function Loader() {
  return (
    <va-loading-indicator label="Loading" message="Loading..." set-focus />
  );
}
